import * as types from '../actionTypes/lookupCode'

let defaultState = {
  employeeRestrictions: [],
  lobbyistStatuses: [],
  annualReturnTypes: []
}

const lookupCodeReducer = (state = defaultState, action) => {
  if (action.type === types.GET_EMPLOYEE_RESTRICTIONS) {
    return {
      ...state,
      employeeRestrictions: action.employeeRestrictions
    }
  } else if (action.type === types.GET_LOBBYIST_STATUSES) {
    return {
      ...state,
      lobbyistStatuses: action.lobbyistStatuses
    }
  } else if (action.type === types.GET_ANNUAL_RETURN_TYPES) {
    return {
      ...state,
      annualReturnTypes: action.annualReturnTypes
    }
  } else {
    return {
      ...state
    }
  }
}

export default lookupCodeReducer



// WEBPACK FOOTER //
// ./src/reducers/lookupCode.js